import React, { useCallback, useEffect, useState } from 'react';
import {
  View,
  Text,
  FlatList,
  TextInput,
  TouchableOpacity,
  ScrollView,
  useWindowDimensions,
} from 'react-native';
import { useCssStyle } from '../../../customHook/getCssStyle';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { clearSelectedItems, updateSelectedRequestItems } from '../../../Redux/Reducers/guestRequestReducer';
import HeaderWithBack from '../../../components/Header/headerWithBack';
import { ImageComp } from '../../../components/Image/Image';
import { CROSS } from '../../../assets';
import CustomPressable from '../../../components/customPressable/customPressable';
import { setGoHome } from '../../../Redux/Reducers/appConfigReducer';
import CustomFlatList from '../../../components/customFlatList';
import { generateToken, getCleanUrl } from '../../../utils/Helper';
import { sendGuestRequest } from '../../../Redux/Actions/guestRequestAction';
import FetchingDataScreen from '../../../components/fetchingDataScreen';
import { CustomTextInput } from '../../../components/customTextInput';
import { useFocusEffect, useRoute } from '@react-navigation/native';
import { sendAnalytics } from '../../../Redux/Actions/analyticsAction';
import { GUEST_REQUEST_CATEGORY } from '../../../config/Constant';
import RenderHTML from 'react-native-render-html';


const GuestRequestDetails_Potrait = ({ navigation }) => {

  const route = useRoute();
  const { widgetDisplayName, guestRequestSessionId } = route.params || {};
  

  const { currentWidget } = useSelector(state => state.deviceConfigSlice);
  const storeName = currentWidget?.displayName; 
  


  const dispatch = useDispatch();
  const getStyles = useCssStyle();
  const { t } = useTranslation();
  const {width} = useWindowDimensions();


  const { selectedItems } = useSelector(state => state.guestRequestSlice);

  const [loaderState, setLoaderState] = useState({
    showLoader: false,
    loaderMessage: ""
  });

  const toggleLoaderState = (state, message) => {
    setLoaderState({
      showLoader: state,
      loaderMessage: state ? message : ""
    })
  }



  const [additionalDetails, setAdditionalDetails] = useState('');





  const placeRequest = async () => {

    toggleLoaderState(true, "Placing order...");


    const requestDetails = selectedItems.map(item => ({
      serviceRequestId: item.serviceRequestId,
      quantity: 1,
      additionalNote: additionalDetails
    }));

    const requestResponse = await dispatch(sendGuestRequest(requestDetails));

    toggleLoaderState(false, "");
    dispatch(sendAnalytics(GUEST_REQUEST_CATEGORY, requestResponse.status == "SUCCESS" ? "GUESTREQUEST - SUCCESS" : "GUESTREQUEST - FAILED", { element: "widget", "widgetSessionId": guestRequestSessionId, storeSku: currentWidget.storeSku, storeName: storeName, errorMessage: requestResponse.message, }));
    if (requestResponse.status == "SUCCESS") {
      dispatch(clearSelectedItems());
    }
  }






  const handleRemoveItem = item => {
    dispatch(updateSelectedRequestItems(item));
  };



  const handleGoBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
      return;
    }

    dispatch(setGoHome(true));
  }

  useEffect(() => {
    if (selectedItems.length === 0) {
      handleGoBack();
      return;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItems]);


  useEffect(() => {
    dispatch(sendAnalytics(GUEST_REQUEST_CATEGORY, "GUESTREQUEST MYORDER PAGE", { element: "widget", "widgetSessionId": guestRequestSessionId, storeSku: currentWidget.storeSku, storeName: storeName}))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  const renderItem = ({ item }) => (

    <View style={getStyles(['list_itemContainer', 'guestrequestdetails_itemContainer'])} id='list_itemContainer guestrequestdetails_itemContainer'>

      {item?.imageName && <ImageComp
        source={getCleanUrl(item?.imageName)}
        style={getStyles(['list_itemContainer_image', 'guestrequestdetails_itemContainer_image'])}
      />}

      <View style={getStyles(['list_itemContainer_textContainer', 'guestrequestdetails_itemContainer_textContainer'])}>
        {item?.name && <Text style={getStyles(['list_itemContainer_textContainer_title', 'guestrequestdetails_itemContainer_textContainer_title'])} id='list_itemContainer_textContainer_title guestrequestdetails_itemContainer_textContainer_title'>{item.name}</Text>}
        {item?.description && <Text style={getStyles(['list_itemContainer_textContainer_subtitle', 'guestrequestdetails_textContainer_subtitle'])} numberOfLines={2} ellipsizeMode="tail" id="list_itemContainer_textContainer_subtitle guestrequestdetails_textContainer_subtitle">{item.description}</Text>}
      </View>

      <CustomPressable onPress={() => handleRemoveItem(item)} style={getStyles(['list_itemContainer_arrow', 'guestrequestdetails_itemContainer_arrow'])} id="list_itemContainer_arrow guestrequestdetails_itemContainer_arrow">
        <ImageComp source={CROSS} style={getStyles(['list_itemContainer_arrow_img', 'guestrequestdetails_itemContainer_arrow_img'])} id="list_itemContainer_arrow_img guestrequestdetails_itemContainer_arrow_img"/>
      </CustomPressable>
    </View>
  );

  const customGuestRequestTitleStyle = getStyles([
    'widgetmainContainerHeaderTitle',
    'guestrequestdetails_HeaderTitle'
  ]);
   const baseTitleStyle = {
            ...customGuestRequestTitleStyle,
            fontFamily: Array.isArray(customGuestRequestTitleStyle.fontFamily)
              ? customGuestRequestTitleStyle.fontFamily[0]
              : customGuestRequestTitleStyle.fontFamily
          }
  const systemFonts = Array.isArray(customGuestRequestTitleStyle.fontFamily)
              ? customGuestRequestTitleStyle.fontFamily
              : [customGuestRequestTitleStyle.fontFamily]


  const customGuestRequestSubTitleStyle = getStyles([
    'widgetmainContainerHeaderTitle',
    'guestrequestdetails_HeaderSubTitle'
  ]);
   const baseSubTitleStyle = {
            ...customGuestRequestSubTitleStyle,
            fontFamily: Array.isArray(customGuestRequestSubTitleStyle.fontFamily)
              ? customGuestRequestSubTitleStyle.fontFamily[0]
              : customGuestRequestSubTitleStyle.fontFamily
          }
  const systemSubFonts = Array.isArray(customGuestRequestSubTitleStyle.fontFamily)
              ? customGuestRequestSubTitleStyle.fontFamily
              : [customGuestRequestSubTitleStyle.fontFamily]

  const renderHeader = () => (
    <View style={getStyles(['widgetmainContainerHeaderContainer', 'guestrequestdetails_HeaderContainer'])} id='widgetmainContainerHeaderContainer guestrequestdetails_HeaderContainer'>
      <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'guestrequestdetails_HeaderTitleContainer'])} id='widgetmainContainerHeaderTitleContainer guestrequestdetails_HeaderTitleContainer'>
        
        <RenderHTML 
          contentWidth={width}
          baseStyle={baseTitleStyle}
          source={{html:  t("guestRequest.my_request")}}
          systemFonts={systemFonts}
          id={`widgetmainContainerHeaderTitle guestrequest_HeaderTitle`}
        />
      </View>
   </View>
  )

  return (
    <View style={getStyles(['widgetRootContainer', 'guestrequestdetails_RootContainer'])} id='widgetRootContainer guestrequestdetails_RootContainer'>
      <HeaderWithBack handleCustomBackPress={handleGoBack} />

      <ScrollView automaticallyAdjustKeyboardInsets={true} 
        contentContainerStyle={getStyles(['widgetmainContainer', 'guestrequestdetails_MainContainer'])} 
        id='widgetmainContainer guestrequestdetails_MainContainer'
      >
        {renderHeader()}


        <View style={getStyles(['widgetmainContainerChildContainer', 'guestrequestdetails_MainContainerChildContainer'])} id='widgetmainContainerChildContainer guestrequestdetails_MainContainerChildContainer' >
            <CustomFlatList
              data={selectedItems}
              nestedScrollEnabled={true}
              renderItem={renderItem}
              showsVerticalScrollIndicator={true}
              keyExtractor={item => item.serviceRequestId.toString()}
              contentContainerStyle={getStyles(["guestrequestdetails_MainContainerChildContainerListContainer"])}
            />
        </View>
        
        <View style={getStyles(['guestRequestDetailsFooterCotainer'])} id='guestRequestDetailsFooterCotainer'>
          <View style={getStyles(['textContainer'])} id='textContainer'>
            <Text style={getStyles(['label', 'guestRequestDetailsFooterTextInoutLabel'])} id='label guestRequestDetailsFooterTextInoutLabel'>{t('guestRequest.additional')}</Text>
            <CustomTextInput
              style={getStyles([{ height: 100 }, "guestRequestDetailsFooterTextInout"])}
              value={additionalDetails}
              onChangeText={setAdditionalDetails}
              placeholder="Add your special requests here"
              multiline
              numberOfLines={3}
            />
          </View>


        </View>
      </ScrollView>
      <View style={getStyles(['guestrequestdetails_buttonContainer'])} id='guestrequestdetails_buttonContainer'>

        <CustomPressable style={getStyles(['primaryBtn', 'guestrequestdetails_primarybuttonContainer'])} onPress={placeRequest} id="primaryBtn guestrequestdetails_primarybuttonContainer">
          <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>{t('guestRequest.send_request')}</Text>
        </CustomPressable>
      </View>
      


      {loaderState.showLoader && <FetchingDataScreen loaderMessage={loaderState.loaderMessage} />}
    </View>
  );
};

export default GuestRequestDetails_Potrait;
